module.exports = __webpack_public_path__ + "img/characters_Art.495f7d66.png";